import { useDispatch, useSelector } from 'react-redux'
import { setlauncherContent, setMessengerTabState, setWidgetTab } from 'app/redux/widget/widget.actions'
import { setActiveDepartment } from 'app/redux/messages/messages.actions'
import { setRecordingAudio, setVoiceRecording } from 'app/redux/messages/messages.actions'
import { BackIcon } from 'app/components/icons'
import { LAUNCHER_CONTENT_STATE, MESSENGER_TAB_STATE } from 'app/constants/launcherContentStates'
import './index.scss'

const getRecordingAudio = ({ messagesData }) => messagesData.messages.recordingAudio
const getVoiceRecording = ({ messagesData }) => messagesData.messages.voiceRecording
const getFaqs = ({ widgetData }) => widgetData.widgetInfo.faq
const getDepartments = ({ widgetData }) => widgetData.widgetInfo.data?.teams
const getPrevTab = ({ widgetData }) => widgetData.widgetInfo.prevTab
const getLauncherInfo = ({ widgetData }) => widgetData.widgetInfo.launcherInfo

function ArrowBackIcon() {
  const recordingAudio = useSelector(getRecordingAudio)
  const voiceRecording = useSelector(getVoiceRecording)
  const faqs = useSelector(getFaqs)
  const departments = useSelector(getDepartments)
  const prevTab = useSelector(getPrevTab)
  const launcherInfo = useSelector(getLauncherInfo)

  const dispatch = useDispatch()

  const handleBackBtnClick = () => {
    if (faqs?.length) {
      if (launcherInfo.content !== LAUNCHER_CONTENT_STATE.MAIN_COVER) {
        dispatch(setlauncherContent(LAUNCHER_CONTENT_STATE.MAIN_COVER))
      }

      if (departments) {
        if (prevTab === 2) {
          dispatch(setWidgetTab(2))
          return
        }

        if (prevTab === 1) {
          if (departments?.length > 1) {
            dispatch(setMessengerTabState(MESSENGER_TAB_STATE.DEPARTMENTS))
            return
          }
          // return to home tab
          dispatch(setWidgetTab(0))
          return
        }

        if (prevTab === 0) {
          // return to home tab
          dispatch(setWidgetTab(0))
        }
      }
    } else {
      if (departments?.length) {
        if (departments.length === 1) {
          const departmentId = departments[0]._id
          dispatch(setActiveDepartment(departmentId))
          dispatch(setlauncherContent(LAUNCHER_CONTENT_STATE.FIRST_CHAT))
        } else {
          dispatch(setlauncherContent(LAUNCHER_CONTENT_STATE.MAIN_COVER))
          dispatch(setActiveDepartment(null))
          dispatch(setWidgetTab(0))
        }
      } else dispatch(setlauncherContent(LAUNCHER_CONTENT_STATE.FIRST_CHAT))
    }

    if (voiceRecording) {
      dispatch(setVoiceRecording(false))
    }
    if (recordingAudio) {
      dispatch(setRecordingAudio(false))
    }
  }

  return (
    <div onClick={handleBackBtnClick} className="chat_back_icon">
      <BackIcon color={'#ffffff'} />
    </div>
  )
}

export default ArrowBackIcon
